<template>
  <div class="stage ion-activable" v-if="stage">
    <div style="display: flex; flex-direction: row; justify-content: space-between; padding-bottom: 1vh; border-bottom: 1px solid #ccc; margin-bottom: 1vh">
      <div><strong>Kỳ</strong>: {{ stage.name }}</div>
      <div><strong>Ngày xổ</strong>: <span class="date">{{ $moment(stage.draw_at).format("dddd DD/MM/YYYY") }}</span></div>
    </div>

    <div>Giải nhất</div>
    <div class="first">
      <div class="balls">
        <span class="ball" v-for="(num, nid) in stage.results[0]" :key="nid">{{ num }}</span>
      </div>
    </div>

    <div>Giải nhì</div>
    <div class="second">
      <div class="balls">
        <span class="ball" v-for="(num, nid) in stage.results[1]" :key="nid">{{ num }}</span>
      </div>
      <div class="balls">
        <span class="ball" v-for="(num, nid) in stage.results[2]" :key="nid">{{ num }}</span>
      </div>
    </div>

    <div>Giải ba</div>
    <div class="third">
      <div class="balls">
        <span class="ball" v-for="(num, nid) in stage.results[3]" :key="nid">{{ num }}</span>
      </div>
      <div class="balls">
        <span class="ball" v-for="(num, nid) in stage.results[4]" :key="nid">{{ num }}</span>
      </div>
      <div class="balls">
        <span class="ball" v-for="(num, nid) in stage.results[5]" :key="nid">{{ num }}</span>
      </div>
    </div>

    <div class="csl">
      <div>
        <div>
          Khuyến khích 1
        </div>
        <div class="csl1 balls" style="border:none">
          <span class="ball" v-for="(num, nid) in stage.results[6]" :key="nid">{{ num }}</span>
        </div>
      </div>
      <div>
        <div>
          Khuyến khích 2
        </div>
        <div class="csl2 balls">
          <span class="ball" v-for="(num, nid) in stage.results[7]" :key="nid">{{ num }}</span>
        </div>
      </div>
    </div>
    <ion-ripple-effect></ion-ripple-effect>
  </div>
</template>

<style scoped>
  .stage {
    padding: 2vw;
    text-align: center;
  }

  .stage .date {
    text-transform: capitalize;
  }

  .stage .balls {
    display: flex;
    flex-direction: row;
    padding: 0.5vw 1.5vw;
    border-left: 1px solid #ccc;
    margin: 0.5vh 1vw;
    margin-right: 0;
    padding-right: 0;
  }

  .stage .balls:first-child {
    border: none;
  }

  .stage .balls .fakeball {
    border: none;
  }

  .stage .balls .ball, .fakeball {
    width: 6vw;
    height: 6vw;
    border-radius: 50%;
    border: 1px solid #ccc;
    font-size: 0.9em;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1px;
  }

  .stage .csl1.balls .ball:nth-child(1) {
    color: #999;
  }

  .stage .csl2.balls .ball:nth-child(1), .stage .csl2.balls .ball:nth-child(2) {
    color: #999;
  }

  .stage .first, .stage .second {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .stage .third {
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: center;
  }

  .stage .csl {
    display: grid;
    grid-template-columns: repeat(4, auto);
    justify-content: center;
  }

  .stage .first .balls .ball {
    background: #d00;
    border-color: #d00;
    color: #fff;
  }

  .stage .second .balls .ball {
    background: #66106F;
    border-color: #66106F;
    color: #fff;
  }
  .stage .third .balls .ball {
    background: #a59600;
    border-color: #a59600;
    color: #fff;
  }

  .stage .csl .balls .ball {
    color: #c00;
    border: 1px solid #999
  }

  .stage .csl .balls:first-child .ball {
    color: #999;
  }

</style>

<script>
  import { defineComponent } from 'vue';
  import {
    IonRippleEffect,
  } from '@ionic/vue';

  export default defineComponent({
    name: 'Max4dResult',
    props: ['stage'],
    components: {
      IonRippleEffect,
    },
  });
</script>
